<template>
	<div class="subscribe_date bg-white">
		<van-tabs v-model="modelValue" line-height="0">
			<van-tab v-for="(item, index) in options" :key="`date_tab_${index}`">
				<template #title>
					<div class="tab_item">
						<p class="title">{{ item.title }}</p>
						<p class="date">{{ item.date }}</p>
						<p class="status primary" v-if="item.status">可约</p>
						<p class="status" v-else>不可约</p>
					</div>
				</template>
			</van-tab>
		</van-tabs>
	</div>
</template>

<script>
export default {
    name: 'subscribe-doctor-item',
    props: {
        value: {
            type: [String, Number],
            default: 0
        },
        options: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        modelValue: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        }
    }
};
</script>

<style scoped lang="less">
.subscribe_date {
	.tab_item {
		box-sizing: border-box;
		width: 132px;
		padding: 14px 0;
		border-radius: 12px;
		text-align: center;
		transition: all 0.3s ease-out;
		.title {
			font-family: PingFangSC-Regular;
			font-size: 24px;
			font-weight: normal;
			color: @gray-9;
		}
		.date {
			margin: 10px 0;
			font-family: DINAlternate-Bold;
			font-size: 30px;
			font-weight: normal;
			letter-spacing: -1px;
			color: #1f2329;
		}
		.status {
			font-family: PingFangSC-Medium;
			font-size: 22px;
			font-weight: 500;
			color: @gray-9;
			&.primary {
				color: @primary;
			}
		}
	}
}
</style>

<style lang="less">
.subscribe_date {
	.van-tabs {
		.van-tabs__wrap {
			height: initial;
			.van-tabs__nav {
				padding: 32px;
				min-height: 148px;
				.van-tabs__line {
					display: none;
				}
				.van-tab {
					padding: 0;
					& + .van-tab {
						padding-left: 10px;
					}
					.van-tab__text {
						display: block;
					}
					&.van-tab--active {
						.tab_item {
							background-color: @primary;
							.title,
							.date,
							.status {
								color: #fff;
							}
						}
					}
				}
			}
		}
	}
}
</style>
